import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEditBookMutation } from "../features/api/apiSlice";

function EditBook() {
  const { state } = useLocation();
  console.log(state)
  const navigate = useNavigate();
  const [editBook] = useEditBookMutation();
  const {
    id,
    editName,
    editAuthor,
    editThumbnail,
    editPrice,
    editRating,
    editFeatured,
  } = state;
  const [name, setName] = useState(editName);
  const [author, setAuthor] = useState(editAuthor);
  const [thumbnail, setThumbnail] = useState(editThumbnail);
  const [price, setPrice] = useState(editPrice);
  const [rating, setRating] = useState(editRating);
  const [featured, setFeatured] = useState(editFeatured);
  const reset = () => {
    setName("");
    setAuthor("");
    setThumbnail("");
    setPrice("");
    setRating("");
    setFeatured(false);
  };
  const updateBookHandler = (event) => {
    event.preventDefault();
    editBook({
      id,
      data: {
        name,
        author,
        thumbnail,
        price: Number(price),
        rating: Number(rating),
        featured,
      },
    });
    reset();

    navigate("../");
  };
  return (
    <main className="py-6 2xl:px-6">
      <div className="container">
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
          <h4 className="mb-8 text-xl font-bold text-center">Edit Book</h4>
          <form className="book-form" onSubmit={updateBookHandler}>
            <div className="space-y-2">
              <label htmlFor="lws-bookName">Book Name</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-bookName"
                name="name"
                value={name}
                onChange={e=>setName(e.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-author">Author</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-author"
                name="author"
                value={author}
                onChange={e=>setAuthor(e.target.value)}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-thumbnail">Image Url</label>
              <input
                required
                className="text-input"
                type="text"
                id="lws-thumbnail"
                name="thumbnail"
                value={thumbnail}
                onChange={e=>setThumbnail(e.target.value)}
              />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
              <div className="space-y-2">
                <label htmlFor="lws-price">Price</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="lws-price"
                  name="price"
                  value={price}
                  onChange={e=>setPrice(e.target.value)}
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="lws-rating">Rating</label>
                <input
                  required
                  className="text-input"
                  type="number"
                  id="lws-rating"
                  name="rating"
                  min="1"
                  max="5"
                  value={rating}
                  onChange={e=>setRating(e.target.value)}
                />
              </div>
            </div>

            <div className="flex items-center">
              <input
                id="lws-featured"
                type="checkbox"
                name="featured"
                className="w-4 h-4"
                checked={featured}
                onChange={e=>setFeatured(e.target.checked)}
              />
              <label htmlFor="lws-featured" className="ml-2 text-sm">
                {" "}
                This is a featured book{" "}
              </label>
            </div>

            <button type="submit" className="submit" id="lws-submit">
              Edit Book
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}

export default EditBook;
